import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from '@ashvin27/react-datatable';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import axios from "axios";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddContest from "../partials/AddContest";
import LiveContest from "../partials/contest/LiveContest";
import UpcomingContest from "../partials/contest/UpcomingContest";
import PastContest from "../partials/contest/PastContest";
import MyContest from "../partials/contest/MyContest";
import CommunityContest from "../partials/contest/CommunityContest";
import LeaderboardGloble from "../partials/exchange/LeaderboardGloble";
import ContestUpdateModal from "../partials/ContestUpdateModal";
import socketIOClient from "socket.io-client";
import {toast,Toaster } from 'react-hot-toast';
import * as myConstList from '../../BaseUrl';
import ReactGA from 'react-ga';
import moment from 'moment';

const jwtToken = localStorage.getItem("jwtToken");
const configToken = {
    headers: {
      Authorization: 'Bearer '+`${localStorage.getItem("jwtToken")}`,
    },
  };
const toastStyles = {
    style: {
      borderRadius: '10px',
      background: '#fff',
      color: '#000',
    },
  }
const baseUrl = myConstList.baseUrl;
const callBackBaseUrl = myConstList.callBackBaseUrl;
class PredictionContest extends Component {

    constructor(props) {
        super(props);
        this.columns = [
            {
                key: "_id",
                text: "Id",
                className: "id",
                align: "left",
                sortable: true,
                cell:(row,index)=>index+1
            },
            {
                key: "Name",
                text: "name",
                className: "Name",
                align: "left",
                sortable: true
            },
            {
                key: "trades",
                text: "Trades",
                className: "trades",
                align: "left",
                sortable: true,
            },
            {
                key: "profit",
                text: "Profit Generated %",
                className: "profit",
                align: "left",
                sortable: true
            }         
         
        ];

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            filename: "Users",
            no_data_text: 'No user found!',
            button: {
                excel: true,
                print: true,
                csv: true
            },
            language: {
                length_menu: "Show _MENU_ result per page",
                filter: "Filter in records...",
                info: "Showing _START_ to _END_ of _TOTAL_ records",
                pagination: {
                    first: "First",
                    previous: "Previous",
                    next: "Next",
                    last: "Last"
                }
            },
            show_length_menu: true,
            show_filter: true,
            show_pagination: true,
            show_info: true,
        };

        this.state = {
            records: [],
            livePairData: [],
            upcomingData: [],
            pastData: [],
            cmContestData:[],
            myContestData:[],
            leaderboard:[],
            leaderboardGloble:[],
            bonus:0,
            scoketFlagOld:0,
            scoketContestChnage:0,
            thirdPhaseConfig:"",      
            contestType:this.props.match.params.contestType, 
            winningCash:0,
            winningWalletBalance:0,
            cashWalletBalance:0,
            totalPoints:0,
            serverTime:'',
        };

        this.state = {
            currentRecord: {
                id: '',
                contestLogo: '',
                contestName: '',
                startTime: '',
                endTime: '',
                entryFee: '',
                virtualFund: '',
            }
        };

       // this.getData = this.getData.bind(this);
        const url = window.location.href;
        const lastSegment = url.split("/").pop();
       
    }
  
    componentDidMount() {
        if (!this.props.auth.isAuthenticated) {                
            window.location = callBackBaseUrl+"?callBack="+window.location.origin;
        }
        // console.log("profile-data==");
        // .post(baseUrl + "api/profile-data", {},configToken)
        axios
        .post(baseUrl + "api/profile-data", {})
        .then(res => {
            // console.log("profile-data=======",res.data.data);
            this.setState({ bonus: res.data.data.bonus,winningWalletBalance: res.data.data.winningamount,cashWalletBalance: res.data.data.cashWalletBalance,totalPoints:res.data.data.totalPoints,winningCash: res.data.data.winningCash })
        })
        .catch()
        this.setState({scoketFlagOld:0,scoketContestChnage:0});
        this.getData();
        
    };
    getData=(exchnageTypeId)=> {
        const socket = socketIOClient(baseUrl, {query:"jwtToken=" +jwtToken+"&&exchnageTypeId="+exchnageTypeId+"&&contestType=coin" });
        this.setState({ socketCollect: socket });
        var collectThis = this;
    
        // client-side
        // socket.on("connect", () => {
        //     collectThis.setState({ currentSocketId: socket.id });
        //     socket.emit("callContestData");
            
            
        // });

        socket.on("connect", () => {
            collectThis.setState({ currentSocketId: socket.id });
            socket.emit("socketFlag");
            
        });
        socket.emit("config3rdphase");
        socket.emit("callContestData",exchnageTypeId);

        socket.on("3rdPhaseConfig", function (apiRespData) {
            if (socket.id == collectThis.state.currentSocketId) {
                var arr = [];
                arr['account']= apiRespData.data[0].account;
                arr['transaction']= apiRespData.data[0].transaction;
                collectThis.setState({ thirdPhaseConfig: arr });
            }
        });
        // console.log("exchnageTypeId==",exchnageTypeId);
        socket.on("livePairData", function (apiRespData) {
            // console.log("livePairData==",apiRespData.data);
            collectThis.setState({ livePairData: apiRespData.data })
        })
        socket.on("upcomingContestData", function (apiRespData) {
                collectThis.setState({ upcomingData: apiRespData.data })
        })
        socket.on("pastContestData", function (apiRespData) {
            collectThis.setState({ pastData: apiRespData.data })
        })
        socket.on("communityContestData", function (apiRespData) {
            collectThis.setState({ cmContestData: apiRespData.data })
        })
        socket.on("socketFlagData", function (apiRespData) {
            if(collectThis.state.scoketFlagOld !== apiRespData.data.contest_flag){
                socket.emit("callContestData");
                socket.on("livePairData", function (apiRespData) {
                        collectThis.setState({ livePairData: apiRespData.data })
                })


                socket.on("upcomingContestData", function (apiRespData) {
                        collectThis.setState({ upcomingData: apiRespData.data })
                })


                socket.on("pastContestData", function (apiRespData) {
                        collectThis.setState({ pastData: apiRespData.data })
                })

                socket.on("myContestData", function (apiRespData) {
                    // console.log("mycontest===",apiRespData.data.pastList );
                        collectThis.setState({ myContestData: apiRespData.data })
                })
                socket.on("communityContestData", function (apiRespData) {
                    collectThis.setState({ cmContestData: apiRespData.data })
                })

                socket.on("serverTime", function (apiRespData) {
                        collectThis.setState({ serverTime: apiRespData })
                })
                collectThis.setState({scoketFlagOld:apiRespData.data.contest_flag});
            }else{
                collectThis.setState({ serverTime: apiRespData })
            }
        })
        axios
        .post(baseUrl + "api/exchange-type-data", configToken)
        .then((res) => {
            this.setState({ exchnage_type: res.data.data });
        })
        .catch();
    }    
    
    handleGoBack = () => {
        this.props.history.goBack();
    };
    componentWillUnmount(){
      //  clearInterval(this.intervalcontest);
        var getSocket = this.state.socketCollect;
        getSocket.emit("disconnectContestApi");

    }
    editRecord(record) {
        this.setState({ currentRecord: record });
    }
    
    deleteRecord(record) {
        axios
            .post(baseUrl+"api/contest-delete", { _id: record._id })
            .then(res => {
                if (res.status === 200) {
                    toast.success(res.data.message, toastStyles);
                }
            })
            .catch();
        this.upcomingRecord();
        this.pastRecord();
    }

    onChange = (e) => {
        // console.log("e.target.value=",e.target.value);
        if (e.target.id === "exchnageTypeId") {
            // console.log("exchnagetypedata aa hai ===",e.target.value);
            this.getData(e.target.value);
            this.setState({
              exchnageTypeId: e.target.value
            });
            
            // axios
            // .post(baseUrl + "api/pair-data-by-ExchnageId",{'exchnageTypeId':e.target.value}, configToken)
            // .then((res) => {
            //   this.setState({ records: res.data.data });
            // })
            // .catch();
        }
    }
    multiSelectOptionExchangeType = () => {
        const html = [];
        // console.log("this.state.exchnage_type=",this.state.exchnage_type);
        if (this.state.exchnage_type != undefined && this.state.exchnage_type.length > 0) {
            this.state.exchnage_type.map(function (value, i) {
                html.push(
                    <>
                        <option value={value.id}>{value.name}</option>
                    </>
                );
            })
        }
        return html;
    }
    
    tabClick(tabType){
        window.webengage.track('Contest_category viewed', {
            'Category Name':tabType
        });
    }
    pageChange(pageData) {
        // console.log("OnPageChange", pageData);
    }
    
    render() {
        
        return (
            <>
                <Navbar urlPath={true} symbol={false} thirdPhaseConfig={this.state.thirdPhaseConfig}/>
                <Sidebar />
                <div className="in_page">
                    <div className="container">
                        <div className="section-heading trending-heading d-flex align-items-center justify-content-between">
                            <h3>Predict Coin Price Contest</h3>
                            <button className="btn btn-primary back-btn" onClick={this.handleGoBack}>Back</button>
                        </div>
                    <div className="row mt-2">   
                        {/* {this.state.thirdPhaseConfig=='on' &&                           
                              <div className="col-md-4 order-md-2 mb-3 mb-md-0">
                                <select onChange={this.onChange}
                                  value={this.state.exchnageTypeId}
                                  id="exchnageTypeId"
                                  className="form-control"
                                >
                                  <option value="">Select</option>
                                  <option value="All">All</option>
                                  {this.multiSelectOptionExchangeType()}
                                </select>
                              </div> }
                        */}
                        <div className="col-12 order-md-1">
                            <ul className="nav contatcs-tab" id="crypt-tab" >
                                <li role="presentation"><a className={(this.props.match.params.type==="live" ||this.props.match.url==="/contest")?"active show":""} href="#tabLive" data-toggle="tab" onClick={() => this.tabClick('Live Contest')}>Live Contest</a></li>                                    
                                <li role="presentation"><a className={this.props.match.params.type==="past"?"active show":""} href="#tabPast" data-toggle="tab" onClick={() => this.tabClick('Past Contest')}>Past Contest</a></li>
                                <li role="presentation"><a className={this.props.match.params.type==="upcoming"?"active show":""} href="#tabUpcoming" data-toggle="tab" onClick={() => this.tabClick('Upcoming Contest')}>Upcoming Contest</a></li>
                                <li role="presentation"><a className={this.props.match.params.type==="my"?"active show":""} href="#tabMy" data-toggle="tab" onClick={() => this.tabClick('My Contest')}>My Contest</a></li>                            
                            </ul>
                        </div>
                    </div>
                        
                        {/* <div className="owl-carousel owl-theme"> */}
                        <div className="tab-content">

                            <div className={(this.props.match.params.type==="live"||this.props.match.url==="/contest")?"tab-pane contest-slider active show":"tab-pane"} id="tabLive">                                
                                    <LiveContest serverTime={this.state.serverTime} record={this.state.livePairData} bonus={this.state.bonus}  winningWalletBalance={this.state.winningWalletBalance} cashWalletBalance={this.state.cashWalletBalance} totalPoints={this.state.totalPoints} winningCash={this.state.winningCash} contestCreated="Admin"/>
                            </div>
                            <div className={this.props.match.params.type==="upcoming"?"tab-pane active contest-slider show":"tab-pane contest-slider"} id="tabUpcoming">
                                    <UpcomingContest serverTime={this.state.serverTime} record={this.state.upcomingData} bonus={this.state.bonus} winningWalletBalance={this.state.winningWalletBalance} cashWalletBalance={this.state.cashWalletBalance} totalPoints={this.state.totalPoints} winningCash={this.state.winningCash} contestCreated="Admin"/>
                            </div>
                            <div className={this.props.match.params.type==="past"?"tab-pane active contest-slider show":"tab-pane contest-slider"} id="tabPast">
                                    <PastContest record={this.state.pastData} bonus={this.state.bonus} contestCreated="Admin"/>
                            </div>
							
							<div className={this.props.match.params.type==="my"?"tab-pane active contest-slider show":"tab-pane contest-slider"} id="tabMy">
                                    <MyContest  serverTime={this.state.serverTime} record={this.state.myContestData} bonus={this.state.bonus} contestCreated="Admin"/>
                            </div>
                        </div>
                        {/* <div className="crypt-market-status2 mt-5 ">
                            <h5 className=" p-md-3  p-2 mb-0">Leaderboard</h5>
                            <LeaderboardGloble leaderboardGloble={this.state.leaderboardGloble}/> */}
                            {/* <ReactDatatable
                                config={this.config}
                                records={this.state.records}
                                columns={this.columns}
                                onPageChange={this.pageChange.bind(this)}
                            /> */}
                        {/* </div> */}
                    </div>
                </div>
                <Footer />
                <Toaster position="bottom-right" reverseOrder={false}/>
            </>
        );
    }

}

PredictionContest.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    auth: state.auth,
    contestdata: state.contestdata,
    records: state.records
});

export default connect(
    mapStateToProps
)(PredictionContest);
